import * as api from './index';

export function getTickets(query) {
    const queryString = (new URLSearchParams(query)).toString();
    return api.get(`/tickets?${queryString}`);
}

export function getTicket(id) {
    return api.get(`/tickets/${id}`);
}

export function createTicket(ticket) {
    return api.post('/tickets', ticket);
}

export function updateTicket(ticket) {
    return api.patch(`/tickets/${ticket.id}`, ticket);
}

export function softDeleteTicket(ticket) {
    return api.del(`/tickets/${ticket.id}/soft`);
}
